import { fork, all } from 'redux-saga/effects';
import { watchAuthorizeAction } from './authorizeApi';
import watchStationListAction from './stationListApi';
import watchStationRecordAction from './stationRecordApi';
import watchStationHistoryAction from './stationHistoryApi';
import watchSmartQueryAction from './smartQueryApi';
import watchFixRecordAction from './fixRecordApi';
import watchStationUploadFileAction from './stationUploadFileApi';

function* rootSagas() {
    yield all([
        fork(watchAuthorizeAction),
        fork(watchStationListAction),
        fork(watchStationRecordAction),
        fork(watchStationRecordAction),
        fork(watchStationHistoryAction),
        fork(watchSmartQueryAction),
        fork(watchFixRecordAction),
        fork(watchStationUploadFileAction),
    ])
}

export default rootSagas;